import { BetaButton } from '@bevy/bevy-design-system';

/**
 * Conforms modal button to specific variants and styles
 */
const ModalButtonBase =
  (variant) =>
  // eslint-disable-next-line react/display-name, react/prop-types
  ({ children, ...props }) => (
    <BetaButton spacing='compact' size='medium' variant={variant} {...props}>
      {children}
    </BetaButton>
  );

export const OutlinedButton = ModalButtonBase('outlined');
export const ContainedButton = ModalButtonBase('contained');
export const TextButton = ModalButtonBase('text');
